import resolveConfig from 'tailwindcss/resolveConfig';
import { useMediaQuery } from 'usehooks-ts';
import tailwindConfig from '../../tailwind.config';
import { keys } from '../lib/objectHelpers';

const fullConfig = resolveConfig(tailwindConfig);

// Get breakpoints from Tailwind config
const breakpoints = fullConfig.theme.screens;

export type Breakpoints = typeof breakpoints;
export type BreakpointKey = keyof Breakpoints;

export const breakpointKeys = keys(breakpoints);

export function useTailwindBreakpoint(breakpoint: BreakpointKey) {
  return useMediaQuery(`(min-width: ${breakpoints[breakpoint]})`);
}
export function useCustomBreakpoint(minWidth: string) {
  return useMediaQuery(`(min-width: ${minWidth})`);
}

export function useAllBreakpoints() {
  return {
    sm: useMediaQuery(`(min-width: ${breakpoints.sm})`),
    md: useMediaQuery(`(min-width: ${breakpoints.md})`),
    lg: useMediaQuery(`(min-width: ${breakpoints.lg})`),
    xl: useMediaQuery(`(min-width: ${breakpoints.xl})`),
    '2xl': useMediaQuery(`(min-width: ${breakpoints['2xl']})`),
    '3xl': useMediaQuery(`(min-width: ${breakpoints['3xl']})`),
    '4xl': useMediaQuery(`(min-width: ${breakpoints['4xl']})`),
    '5xl': useMediaQuery(`(min-width: ${breakpoints['5xl']})`),
  };
}
